// Helper function to process base64 images
export const processBase64Image = (imageData: string): string => {
  if (!imageData) return '';

  // Check if the image already has the base64 prefix
  if (imageData.startsWith('data:image/')) {
    return imageData;
  }

  // Add the prefix if it's missing
  return `data:image/png;base64,${imageData}`;
};
